import { KeyIndexImpl } from '../instructions';
/**
 * @public
 */
export var PluralIndex = new KeyIndexImpl(['other', 'zero', 'one', 'two', 'few', 'many']);
/**
 * @public
 */
export var AltIndex = new KeyIndexImpl(['none', 'short', 'narrow', 'variant', 'stand-alone', 'long', 'menu']);
/**
 * @public
 */
export var EraAltIndex = new KeyIndexImpl(['none', 'sensitive']);
/**
 * @public
 */
export var DayPeriodAltIndex = new KeyIndexImpl(['none', 'casing']);
//# sourceMappingURL=enums.js.map